import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { twJoin } from 'tailwind-merge';

import Text from 'shopper/components/Text';

const Placeholder = forwardRef(
  ({ className, children, disabled = false, error = false }, ref) => (
    <Text
      ref={ref}
      as="span"
      className={twJoin(
        'pointer-events-none',
        disabled
          ? 'text-neutral-low-300 dark:text-neutral-high-500'
          : error
            ? 'text-error-300 dark:text-error-300'
            : 'text-neutral-low-200 dark:text-neutral-high-400',
        className
      )}
    >
      {children}
    </Text>
  )
);

Placeholder.displayName = 'Placeholder';

Placeholder.propTypes = {
  children: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
};

export default Placeholder;
